module.exports = __webpack_public_path__ + "static/img/c2.79832a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Investment/c2.jpg
// module id = n+Fe
// module chunks = 0